import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Grid, Col } from 'react-bootstrap';
import { Authlayout, AuthContent, AuthDescription, Links } from '../styles';
import { urlArgs } from 'scriptjs';
import { Link } from 'react-router-dom';

const propTypes = {
  history: PropTypes.object,
  content: PropTypes.element,
  type: PropTypes.string,
  currentUser: PropTypes.object,
  background: PropTypes.string
};

class AuthLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: ''
    };
  }
  componentDidMount() {
    const { history, currentUser } = this.props;

    // if (currentUser) {
    //   history.push('/');
    // }
  }

  authdescription(title, body, link) {
    return (
      <AuthDescription>
        <h1>{title}</h1>
        <h2>{body}</h2>
        {link}
      </AuthDescription>
    );
  }

  renderType(type) {
    const { __ } = this.context;
    if (type == 'signin') {
      let link = (
        <Links>
          If you don’t have an account{<br />} You can {'  '}
          <Link to="/signup">{__('Register Now')}</Link>
        </Links>
      );
      return this.authdescription(`Welcome Back!`, `Sign In`, link);
    } else if (type == 'TenantSignIn') {
      let link = (
        <Links>
          If you don’t have an account{<br />} You can {'  '}
          <Link to="/sign-in">{__('Register Now')}</Link>
        </Links>
      );
      return this.authdescription(`Welcome Back!`, `Tenant Sign Up`, link);
    } else if (type == 'signup') {
      let link = (
        <Links>
          If you already have an account{<br />} You can {'  '}
          <Link to="/sign-in">{__('Login Now')}</Link>
        </Links>
      );
      return this.authdescription(`Welcome Back!`, `Sign Up`, link);
    } else {
      let link = (
        <Links>
          If you don’t have an account{<br />} You can {'  '}
          <Link to="/sign-in">{__('Register Now')}</Link>
        </Links>
      );
      return this.authdescription(`Welcome Back!`, `OTP`, link);
    }
  }
  render() {
    const { content, type, background } = this.props;
    const { __ } = this.context;

    return (
      <span style={{ width: '100%' }}>
        <Authlayout background={background}>
          <AuthContent>
            <Grid fluid className="">
              <Col md={12}>
                <img
                  src="images/logos.png"
                  // style={{ width: '50px', marginBottom: '0px' }}
                />
              </Col>
            </Grid>
            <Grid fluid className="bgRow">
              <Col md={1}></Col>
              <Col md={5}>{this.renderType(type)}</Col>
              <Col md={5}>{content}</Col>
              <Col md={1}></Col>
            </Grid>
          </AuthContent>
        </Authlayout>
      </span>
    );
  }
}

AuthLayout.propTypes = propTypes;
AuthLayout.contextTypes = {
  __: PropTypes.func
};

export default withRouter(AuthLayout);



// WEBPACK FOOTER //
// src/modules/layout/components/AuthLayout.js